<template>
  <!-- 最外层容器 -->
  <div class="app-container">
    <!-- 侧边栏触发器区域 - 用于检测鼠标靠近 -->
    <div class="sidebar-trigger"></div>
    
    <!-- 侧边栏 -->
    <nav class="sidebar">
      <div class="sidebar-inner">
        <ul class="menu-list">
          <li v-for="(item, index) in menuItems" :key="index">
            <router-link
                :to="item.path"
                class="menu-link"
                :data-text="item.text"
            >
              <span class="link-icon">{{ item.icon }}</span>
              <span class="link-text">{{ item.text }}</span>
              <span class="link-arrow">→</span>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <!-- 主内容区（路由出口） -->
    <div class="main-content">
      <!-- 标题区 -->
      <div class="header-container">
        <div class="navbar-header">
          <div class="header-glow"></div>
          <h1>
            <span class="icon">🐷</span>
           Swine-SDDNet：A Dynamic Feature Fusion Network based on Selective Kernel and Dual-channel Attention for Semantic Segmentation of Pigs in Complex Scenarios</h1>
        </div>
      </div>

      <!-- 路由视图容器 -->
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuItems: [
        { path: 'image', text: 'Image', icon: '🖼️' },  // 图片emoji
        { path: 'video', text: 'Video', icon: '🎥' },   // 视频emoji
        { path: 'folder', text: 'Folder', icon: '📂' }, // 文件夹emoji
        { path: 'camera', text: 'Camera', icon: '📹' }, // 摄像头emoji
        { path: 'results', text: 'Results', icon: '📊' } , // 检测结果emoji和路由
         { path: 'examples', text: 'Examples', icon: '🧪' } 
      ]
    };
  }
};
</script>


<style>
:root {
  --primary-color: #2e7d32;
  --secondary-color: #43a047;
  --accent-color: #81c784;
  --gold-color: #ffc107;
  --text-light: #f5f5f5;
  --glass-effect: rgba(255, 255, 255, 0.85);
  --sidebar-width: 240px;
  --sidebar-collapsed: 34px;
  --trigger-width: 15px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}


body {
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
  background: #f8f9fa;
}

/* 侧边栏触发器 */
.sidebar-trigger {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--trigger-width);
  height: 100vh;
  z-index: 999;
}

/* 侧边栏样式 */
.sidebar {
  width: var(--sidebar-collapsed);
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--glass-effect);
  backdrop-filter: blur(10px);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  padding: 1rem 0;
  z-index: 1000;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

/* 鼠标靠近时展开侧边栏 */
.sidebar-trigger:hover + .sidebar,
.sidebar:hover {
  width: var(--sidebar-width);
  padding: 1rem;
}

.sidebar-inner {
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
}

/* 主内容区 */
.main-content {
  margin-left: var(--sidebar-collapsed);
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 侧边栏展开时调整主内容区 */
.sidebar-trigger:hover ~ .main-content,
.sidebar:hover ~ .main-content {
  margin-left: var(--sidebar-width);
}

/* 标题容器 */
.header-container {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.navbar-header {
  padding: 2rem 3rem;
  position: relative;
  z-index: 2;
}

.header-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 50% 50%,
  rgba(33, 150, 243, 0.2) 0%,
  rgba(33, 150, 243, 0.1) 20%,
  transparent 60%);
  animation: glow 8s infinite linear;
}

@keyframes glow {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.navbar-header h1 {
  font-size: 2.5rem;
  color: var(--text-light);
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
}

.icon {
  font-size: 2.8rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  animation: float 3s ease-in-out infinite;
}

/* 菜单项样式 */
.menu-list {
  margin-top: 1rem;
  list-style: none;
  padding: 0;
}

.menu-link {
  display: flex;
  align-items: center;
  padding: 0.8rem 0;
  margin: 0.5rem 0;
  border-radius: 8px;
  color: var(--primary-color);
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 展开状态下恢复内边距和对齐 */
.sidebar:hover .menu-link {
  padding: 0.8rem 1.2rem;
  justify-content: flex-start;
}

.menu-link:hover {
  background: rgba(33, 150, 243, 0.15);
  transform: translateX(8px);
}

.link-icon {
  font-size: 1.4rem;
  width: 30px;
  text-align: center;
  transition: transform 0.3s ease;
  display: inline-block;
}

/* 展开时增加图标与文字间距 */
.sidebar:hover .link-icon {
  margin-right: 1rem;
}

/* 文本和箭头在收起状态下隐藏 */
.link-text, .link-arrow {
  opacity: 0;
  transition: all 0.3s ease;
  transform: translateX(-10px);
}

/* 侧边栏展开时显示文本和箭头 */
.sidebar:hover .link-text,
.sidebar:hover .link-arrow {
  opacity: 1;
  transform: translateX(0);
}

.link-text {
  font-weight: 500;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-arrow {
  color: var(--accent-color);
}

.menu-link:hover .link-arrow {
  transform: translateX(5px);
}

/* 活动菜单项 */
.menu-link.router-link-exact-active {
  background: linear-gradient(135deg, var(--accent-color), #1976d2);
  color: white;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  :root {
    --sidebar-width: 100%;
    --sidebar-collapsed: 100%;
  }
  
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
    padding: 1rem;
  }
  
  .sidebar-trigger {
    display: none;
  }

  .main-content {
    margin-left: 0;
  }

  .menu-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .menu-link {
    flex-direction: column;
    text-align: center;
    padding: 1rem;
    justify-content: center;
  }
  
  .link-text, .link-arrow {
    opacity: 1;
    transform: translateX(0);
  }

  .link-icon {
    margin: 0 0 0.5rem 0;
  }

  .navbar-header h1 {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .menu-list {
    grid-template-columns: 1fr;
  }

  .navbar-header {
    padding: 1.5rem;
  }

  .icon {
    font-size: 2rem;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* 内容区域 */
.content-wrapper {
  padding: 2rem;
  min-height: calc(100vh - 120px);
}
</style>
